import React, { useState, useEffect, useRef } from 'react';

const Typewriter = ({ text, speed = 50 }) => {
    
  const [displayedText, setDisplayedText] = useState('');
  const [start, setStart] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStart(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!start) return;
    let i = 0;
    const intervalId = setInterval(() => {
      setDisplayedText(text.slice(0, i + 1));
      i++;
      if (i >= text.length) clearInterval(intervalId);
    }, speed);

    return () => clearInterval(intervalId);
  }, [start, text, speed]);

  return (
    <span ref={ref} dangerouslySetInnerHTML={{ __html: displayedText }} />
  );
};

export default Typewriter;
